module.exports = __webpack_public_path__ + "static/media/typeB1.65e614bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/hero/typeB1.png
// module id = 1217
// module chunks = 0